<div *ngIf="ayuntamientosText">
    <app-image-section-head [title]="title" [description]="description" [image]="image"></app-image-section-head>
    
    <div class="container">
        <div class="row">
            <main id="main-content" class="col-12" [innerHTML]="ayuntamientosText"></main>
        </div>
    </div>
</div>